import { Component, OnInit } from '@angular/core';
import { Meta } from '../common/seo.service';
import {Router, ActivatedRoute, Params} from '@angular/router';

@Component({
  selector: 'app-list',
  templateUrl: '../themes/default/html/list.component.html', 
  styleUrls: ['../themes/default/css/list.component.scss']
})
export class ListComponent implements OnInit {

  constructor(private myMeta: Meta, private activatedRoute: ActivatedRoute) {
    myMeta.setTitle('Titolo pagina immobili');
   }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
        let City = params['City'];

      });
  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/list/list.component.ts